import styled from 'styled-components'
import { MenuOutlined } from '@ant-design/icons'

export const HamburgerComponent = styled(MenuOutlined)`
	color: #4E4B4B;
  font-size: 30px;
  cursor: pointer;
`
